import { TranslationKeys } from '~frontend-common/i18n/english/continuously-coverage-subquestion.i18n';

const keys: TranslationKeys = {
  continuouslyCoverage: {
    titles: {
      currentCarrier: 'Qui est votre assureur {{0}} actuel?',
      yearsInsuredWith: 'Depuis combien d’années êtes-vous assuré avec {{0}} en assurance {{1}}?',
      renewalMonth: 'À quel mois votre couverture expire-t-elle avec {{0}}?',
      uninsuredReason: "Pouvez-vous nous dire la raison pour laquelle vous n'êtes pas assuré en ce moment?",
    },
    placeholders: {
      currentCarrier: 'ex. Desjardins',
      renewalMonth: 'ex. Juillet',
      uninsuredReason: 'Raison',
    },
    suffix: {
      currentCarrier: 'votre assureur actuel',
    },
  },
};

export default keys;
